import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Calendar, Clock, Shield } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#1E352F] text-[#F5F0E6] border-t border-[#2D4A43]">
      
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Column 1: Brand & Intro */}
          <div className="space-y-4">
            <div className="flex items-center gap-2.5">
              <img 
                src="https://assets.auxodev.dk/assets/bd5a76fd-d82e-431d-9e97-5b07d543e9b6/16078238-fbcc-4d39-8388-5a0f35514b2c.png" 
                alt="Rørbækklinikken" 
                className="w-28 h-28 object-contain"
              />
            </div>
            <p className="text-sm text-[#F5F0E6]/80 leading-relaxed max-w-xs">
              Professionel, helhedsorienteret muskelterapi, kranio-sakral-terapi og fysiurgisk massage i hjertet af Viborg. Vi har fokus på det hele menneske.
            </p>
            <div className="pt-2 text-xs text-[#F5F0E6]/60">
              CVR-nr: 32389260
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="space-y-4">
            <h3 className="font-serif text-base font-semibold text-white tracking-wide">
              Hurtige links
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-[#F5F0E6]/80 hover:text-white transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="text-[#F5F0E6]/80 hover:text-white transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/klinikken" className="text-[#F5F0E6]/80 hover:text-white transition-colors">
                  Klinikken
                </Link>
              </li>
              <li>
                <Link to="/behandlinger" className="text-[#F5F0E6]/80 hover:text-white transition-colors">
                  Behandlinger
                </Link>
              </li>
              <li>
                <Link to="/videre-forloeb" className="text-[#F5F0E6]/80 hover:text-white transition-colors">
                  Videre forløb
                </Link>
              </li>
              <li>
                <Link to="/gode-erfaringer" className="text-[#F5F0E6]/80 hover:text-white transition-colors">
                  Gode erfaringer
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#F5F0E6]/80 hover:text-white transition-colors">
                  Spørgsmål & Svar
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Opening Hours */}
          <div className="space-y-4">
            <h3 className="font-serif text-base font-semibold text-white tracking-wide flex items-center gap-2">
              <Clock className="w-4 h-4 text-[#eebb53]" />
              Åbningstider
            </h3>
            <ul className="space-y-2.5 text-sm text-[#F5F0E6]/80">
              <li className="flex justify-between border-b border-[#2D4A43] pb-1.5">
                <span>Mandag</span>
                <span className="font-medium">08:00 - 17:00</span>
              </li>
              <li className="flex justify-between border-b border-[#2D4A43] pb-1.5">
                <span>Tirsdag</span>
                <span className="font-medium">08:00 - 17:00</span>
              </li>
              <li className="flex justify-between border-b border-[#2D4A43] pb-1.5">
                <span>Onsdag</span>
                <span className="font-medium">08:00 - 17:00</span>
              </li>
              <li className="flex justify-between border-b border-[#2D4A43] pb-1.5">
                <span>Torsdag</span>
                <span className="font-medium">08:00 - 17:00</span>
              </li>
              <li className="flex justify-between border-b border-[#2D4A43] pb-1.5">
                <span>Fredag</span>
                <span className="font-medium">08:00 - 15:00</span>
              </li>
              <li className="flex justify-between text-[#F5F0E6]/50">
                <span>Lørdag - Søndag</span>
                <span className="font-medium">Lukket</span>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div className="space-y-4">
            <h3 className="font-serif text-base font-semibold text-white tracking-wide">
              Kontakt os
            </h3>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#eebb53] shrink-0 mt-0.5" />
                <span className="text-[#F5F0E6]/80 leading-relaxed">
                  Gravene 28B,<br />8800 Viborg
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#eebb53] shrink-0" />
                <a href="tel:86639393" className="text-[#F5F0E6]/80 hover:text-white transition-colors whitespace-nowrap">
                  86 63 93 93
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#eebb53] shrink-0" />
                <a href="mailto:im@muskelterapi.com" className="text-[#F5F0E6]/80 hover:text-white transition-colors whitespace-nowrap">
                  im@muskelterapi.com
                </a>
              </li>
            </ul>
            <div className="pt-2">
              <Link
                to="/bestil-tid"
                className="inline-flex items-center gap-2 bg-[#eebb53] hover:bg-[#dca63d] text-white text-xs font-semibold uppercase tracking-wider px-4 py-2.5 rounded-full transition-colors w-full justify-center"
              >
                <Calendar className="w-4 h-4" />
                Book tid online
              </Link>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Copyright Bar */}
      <div className="border-t border-[#2D4A43] bg-[#162723] py-6 px-4 sm:px-6 lg:px-8 text-center text-xs text-[#F5F0E6]/60">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
          <p>© {currentYear} Rørbækklinikken I/S. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-1 text-[#F5F0E6]/40">
            <Shield className="w-3.5 h-3.5" />
            <span>Professionel & autoriseret behandling</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
